<template>
  <div class="container">
    <p>{{ paso }} de {{ config.cantPasos() }}</p>
  </div>
</template>

<script>
export default {
  name: "StepCounter",
  props: ["paso"]
};
</script>

<style scoped>
div.container {
  text-align: left;
}

div.container,
p {
  margin-bottom: 0px;
}

p {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: 500;
  font-style: italic;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: -0.3px;
  color: #666666;
}
</style>
